/** OpenPanel client ID — public; keep in sync with OpenPanel dashboard. Never put clientSecret here. */
export const OPENPANEL_CLIENT_ID =
  process.env.REACT_APP_OPENPANEL_CLIENT_ID || '378472a9-88b8-4a45-af10-cff0592619c3';

/** Self-hosted OpenPanel (op.daiv.live) — primary analytics target. Never put clientSecret here. */
export const OPENPANEL_SELF_CLIENT_ID =
  process.env.REACT_APP_OPENPANEL_SELF_CLIENT_ID || 'ef769350-d1f8-420d-a5d2-ce000d4c062d';

export const OPENPANEL_SELF_API_URL =
  process.env.REACT_APP_OPENPANEL_SELF_API_URL || 'https://op.daiv.live/api';

/**
 * Dual-write to OpenPanel Cloud (legacy). On unless `REACT_APP_OPENPANEL_CLOUD_ENABLED=false`
 * (set false on prod when migration to self-hosted-only is approved).
 */
export function isOpenPanelCloudEnabled() {
  return process.env.REACT_APP_OPENPANEL_CLOUD_ENABLED !== 'false';
}

/** Prod API host — OpenPanel runs when this API is configured at build time (same rule as Plausible). */
export const OPENPANEL_PROD_API_HOST = 'vectors.daivbharathi.com';

const OPENPANEL_SITE_HOSTS = [
  'daivbharathi.com',
  'www.daivbharathi.com',
  'daiv.co',
  'www.daiv.co',
];
const OPENPANEL_TEST_HOSTS = ['localhost', '127.0.0.1'];

function parseHostname(url) {
  try {
    return new URL(String(url || '')).hostname.toLowerCase();
  } catch {
    return '';
  }
}

/**
 * Same resolution as src/config/api.js — prefer *_PROD/*_DEV via REACT_APP_ENV,
 * then legacy REACT_APP_API_BASE_URL. Avoids OpenPanel staying off when only *_PROD is set.
 */
function resolveApiBaseUrlForOpenPanel() {
  const mode = String(process.env.REACT_APP_ENV || '').trim().toLowerCase();
  const devUrl = String(process.env.REACT_APP_API_BASE_URL_DEV || '').trim();
  const prodUrl = String(process.env.REACT_APP_API_BASE_URL_PROD || '').trim();
  const legacy = String(process.env.REACT_APP_API_BASE_URL || '').trim();

  if (mode === 'prod' || mode === 'production') return prodUrl || legacy;
  if (mode === 'dev' || mode === 'development') return devUrl || legacy;
  if (process.env.NODE_ENV === 'production') return prodUrl || legacy;
  return prodUrl || legacy || devUrl;
}

/** Explicit test override — set REACT_APP_OPENPANEL_ENABLED=true for localhost. */
export function isOpenPanelTestMode() {
  return process.env.REACT_APP_OPENPANEL_ENABLED === 'true';
}

/** Kill switch for CI — set REACT_APP_OPENPANEL_DISABLED=true to disable all OpenPanel. */
export function isOpenPanelDisabled() {
  return process.env.REACT_APP_OPENPANEL_DISABLED === 'true';
}

/**
 * True when this build targets prod (or local test mode is on).
 * REACT_APP_OPENPANEL_ENABLED=true only forces localhost testing; `false` must not
 * disable prod — prod CI previously set it to false and baked out all tracking.
 */
export function isOpenPanelProdBuild() {
  if (isOpenPanelDisabled()) return false;
  if (isOpenPanelTestMode()) return true;

  const apiHost = parseHostname(resolveApiBaseUrlForOpenPanel());
  return apiHost === OPENPANEL_PROD_API_HOST;
}

export function isOpenPanelAllowedHost(hostname) {
  const host = String(hostname || '').toLowerCase();
  if (OPENPANEL_SITE_HOSTS.includes(host)) return true;
  if (isOpenPanelTestMode() && OPENPANEL_TEST_HOSTS.includes(host)) return true;
  return false;
}

export function isOpenPanelAllowedOnCurrentHost() {
  if (typeof window === 'undefined') return false;
  if (!isOpenPanelProdBuild()) return false;
  if (window.__daivOpenPanelAllowed === false) return false;
  return isOpenPanelAllowedHost(window.location.hostname);
}
